const MD_BREAKPOINT = 744;

export default function initStepTracker() {
  const stepTrackerWraps = document.querySelectorAll(".step-tracker-wrap");
  if (!stepTrackerWraps.length) return;

  stepTrackerWraps.forEach((wrap) => {
    const tracker = wrap.querySelector(".step-tracker");
    if (!tracker) return;

    const trackerLinks = tracker.querySelectorAll("ul li a");
    if (!trackerLinks.length) return;

    const navbarWrapper = document.querySelector(".navbar-wrapper");
    const inpageNav = document.querySelector(".inpage-nav");

    // Get combined offset from navbar and inpage-nav
    function getTopOffset() {
      let offset = 0;

      // Navbar height
      if (navbarWrapper) {
        const navbarContainer =
          navbarWrapper.querySelector(".navbar-container");
        if (navbarContainer) {
          offset += navbarContainer.offsetHeight;
        }
        // Add navbar wrapper padding
        if (window.innerWidth >= MD_BREAKPOINT) {
          offset += 16; // spacing-sm * 2
        } else {
          offset += 8; // spacing-xs * 2
        }
      }

      // Inpage-nav height if visible
      if (inpageNav && inpageNav.classList.contains("is-sticky")) {
        offset += inpageNav.offsetHeight;
        // Add spacing
        if (window.innerWidth >= MD_BREAKPOINT) {
          offset += 16;
        } else {
          offset += 8;
        }
      }

      return offset;
    }

    // Update CSS variable for top offset
    function updateTopOffset() {
      const offset = getTopOffset();
      tracker.style.setProperty("--tracker-top-offset", `${offset}px`);
    }

    // Get target element - search within wrap first, fallback to document
    function getTargetElement(href) {
      if (!href || href === "#") return null;
      const id = href.replace("#", "");
      // Try to find within wrap first
      let target = wrap.querySelector(`#${id}`);
      // Fallback to document if not found in wrap
      if (!target) {
        target = document.getElementById(id);
      }
      return target;
    }

    // Scroll to target element by href
    function scrollToTarget(href) {
      const targetElement = getTargetElement(href);
      if (!targetElement) return;

      const offset = getTopOffset() + 20; // Extra buffer
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }

    // Update active state based on scroll position (href-based)
    function updateActiveState() {
      const topOffset = getTopOffset();

      let activeLink = null;

      trackerLinks.forEach((link) => {
        const href = link.getAttribute("href");
        const targetElement = getTargetElement(href);
        if (!targetElement) return;

        // Use getBoundingClientRect for accurate viewport position
        const rect = targetElement.getBoundingClientRect();

        // Element is active when its top has scrolled past the offset threshold
        // and its bottom is still below the threshold
        if (rect.top <= topOffset + 50 && rect.bottom > topOffset + 50) {
          activeLink = link;
        }
      });

      // Update links
      trackerLinks.forEach((link) => {
        if (link === activeLink) {
          link.classList.add("active");
        } else {
          link.classList.remove("active");
        }
      });
    }

    // Handle scroll
    function handleScroll() {
      updateTopOffset();
      updateActiveState();
    }

    // Handle link clicks
    trackerLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const href = link.getAttribute("href");
        scrollToTarget(href);
      });
    });

    // Throttled scroll handler
    let ticking = false;
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }

    // Initialize
    window.addEventListener("scroll", onScroll);
    window.addEventListener("resize", handleScroll);

    // Initial call
    handleScroll();
  });
}
